import React from 'react'
import {
    FlatList,
    Dimensions,
    TouchableOpacity
} from 'react-native'
import moment from 'moment'
import { Box, VStack, HStack, Text, Button, Image, Select, CheckIcon } from 'native-base'
import { useHeaderHeight } from '@react-navigation/stack'

export default function OrderDetail(props) {
    const { t, order, statusModalVisible, reservationStatusModalVisible, selectedReservationId } = props
    const headerHeight = useHeaderHeight();
    const buttons = [
        { value: 'PENDING' },
        { value: 'CONFIRMED' },
        { value: 'COMPLETE' }
    ]
    console.log(order)
    const { _id, orderId, contact, products, reservations, price, createdAt, userCoupons, deliveryMethod, pickUpStore, trackingNumber, status } = order
    let totalProducts = 0
    let totalReservations = 0
    totalProducts = products.reduce((acc, f) => { return acc + f.quantity }, 0)
    totalReservations = reservations.reduce((acc, f) => { return acc + f.quantity }, 0)
    const discount = userCoupons.reduce((acc, f) => { return acc + f.discount }, 0)

    const renderDeliveyMethodView = (deliveryMethod, contact, pickUpStore, trackingNumber) => {
        const renderAddress = () => {
            switch (deliveryMethod) {
                case 'SFEXPRESS':
                    const { district, room, street } = contact
                    return <Text p={2} fontSize={'xs'}>{`${t('address')}: ${room}, ${street}, ${district}`}</Text>
                case 'SELF_PICK_UP':
                    return <Text p={2} fontSize={'xs'}>{`${t('store')}: ${pickUpStore}`}</Text>
                case 'CONTACT_SELLER':
                    return null
                default:
                    return null
            }
        }
        const renderTrackingView = () => {
            return (
                <Button sixe={'xs'} alignSelf={'flex-start'} onPress={() => props.onTrackingPress(trackingNumber)}>
                    <Text p={2} fontSize={'xs'} color={'primary.100'}>({t('orderTracking')})</Text>
                </Button>
            )
        }
        return (
            <Box>
                <HStack >
                    <Text p={2} fontSize={'xs'}>{`${t('deliveryMethod')}: ${t(deliveryMethod)}`}</Text>
                    {trackingNumber ? renderTrackingView() : null}
                </HStack>
                {renderAddress()}
            </Box>
        )
    }

    const renderOrderDetail = (object) => {
        const { item } = object
        const { _id, photos, name, introduction } = item.product
        const { price, quantity, choices } = item
        const renderChoices = item.choices.map((f, index) => {
            return (
                <Box key={index.toString()}>
                    <Text isTruncated fontSize={'xs'} p={1} >{`${f.choice}`}</Text>
                    <Text isTruncated fontSize={'xs'} p={1} >{f.subchoices.join(', ')}</Text>
                </Box>
            )
        })
        return (
            <HStack borderWidth={1} borderColor={'gray.100'} p={2}>
                <Image size={'xl'} resizeMode={'cover'} bg={'gray.400'} source={{ uri: photos[0].path }} />
                <Box justifyContent={'space-between'}>
                    <VStack>
                        <Text isTruncated fontSize={'xs'} p={1} >{`${name} ${introduction}`}</Text>
                        {renderChoices}
                    </VStack>
                    <HStack >
                        <Text fontSize={'xs'} p={1} >{t('orderQuantity', { quantity: quantity })}</Text>
                        <Text fontSize={'xs'} p={1} >{t('orderTotal', { amount: price.toFixed(1) })}</Text>
                    </HStack>
                </Box>
            </HStack>
        )
    }

    const renderReservationDetail = (object) => {
        const { item } = object
        const { reservation } = item
        const { _id, photos, name, introduction } = reservation.product
        const { price, quantity } = item
        const option = reservation.options.find((f) => { return f._id == item.option })
        return (
            <HStack borderWidth={1} borderColor={'gray.100'} p={2}>
                <Image size={'xl'} resizeMode={'cover'} bg={'gray.400'} source={{ uri: photos[0].path }} />
                <Box justifyContent={'space-between'}>
                    <VStack>
                        <Text isTruncated fontSize={'xs'} p={1} >{`${name} ${introduction}`}</Text>
                        <HStack>
                            <Text isTruncated fontSize={'xs'} p={1} >{`${t('option')}: ${option.name}`}</Text>
                            <Text isTruncated fontSize={'xs'} p={1} >{`${t('quantity')}: ${quantity}`}</Text>
                        </HStack>
                        <Text isTruncated fontSize={'xs'} p={1} >{`${t('reservationTime')}: ${moment(reservation.time).format('YYYY-MM-DD HH:mm')}`}</Text>
                        <Select
                            selectedValue={item.status}
                            accessibilityLabel="Select status"
                            placeholder="Select status"
                            onValueChange={(itemValue) => props.onReservationUpdateStatusPress(item._id, itemValue)}
                            _selectedItem={{
                                endIcon: <CheckIcon size={4} />,
                            }}
                            size={'xs'}
                            alignSelf={'flex-start'}
                        >
                            {buttons.map((f) => {
                                return (
                                    <Select.Item key={f.value} label={t(f.value)} value={f.value} />
                                )
                            })}
                        </Select>
                        <Text fontSize={'xs'} p={1}>{t('orderTotal', { amount: price.toFixed(1) })}</Text>
                    </VStack>
                </Box>
            </HStack>
        )
    }

    const renderOrdersView = () => {
        return (
            <Box py={2}>
                <Text fontWeight={'700'} p={2}>{t('orders')}</Text>
                <FlatList
                    listKey={'order'}
                    data={order.products}
                    renderItem={(object) => renderOrderDetail(object)}
                    keyExtractor={(item, index) => index.toString()}
                />
            </Box>
        )
    }

    const renderReservationView = () => {
        return (
            <Box py={2}>
                <Text fontWeight={'700'} p={2}>{t('reservationOrders')}</Text>
                <FlatList
                    listKey={'reservation'}
                    data={order.reservations}
                    renderItem={(object) => renderReservationDetail(object)}
                    numColumns={1}
                    keyExtractor={(item, index) => index.toString()}
                />
            </Box>
        )
    }

    return (
        <Box h={Dimensions.get('window').height - headerHeight} bgColor={"white"} p={2}>
            <VStack w={'100%'} borderWidth={1} borderColor={'gray.200'}>
                <Text p={2} fontSize={'xs'}>{t('orderCreatedAt', { date: moment(createdAt).format('YYYY-MM-DD') })}</Text>
                <Text p={2} fontSize={'xs'}>{t('orderSummary', { totalProducts: totalProducts, totalReservations: totalReservations, price: price.toFixed(1) })}</Text>
                <Text p={2} fontSize={'xs'}>{`${t('name')}: ${contact.name}`}</Text>
                <Text p={2} fontSize={'xs'}>{`${t('contactNumber')}: ${contact.phoneNumber}`}</Text>
            </VStack>

            <VStack w={'100%'} >
                <Text p={2} fontSize={'xs'}>{t('orderNumber', { orderId: orderId })}</Text>
                <HStack>
                    <Text p={2} fontSize={'xs'}>{t('orderTotal', { amount: price.toFixed(1) })}</Text>
                    <Text p={2} fontSize={'xs'}>{t('orderDiscount', { discount: discount.toFixed(1) })}</Text>
                </HStack>
                <Select
                    selectedValue={status}
                    accessibilityLabel="Select status"
                    placeholder="Select status"
                    onValueChange={(itemValue) => props.onUpdateStatusPress(itemValue)}
                    _selectedItem={{
                        endIcon: <CheckIcon size={4} />,
                    }}
                    alignSelf={'flex-start'}
                    size={'xs'}
                >
                    {buttons.map((f) => {
                        return (
                            <Select.Item key={f.value} label={t(f.value)} value={f.value} />
                        )
                    })}
                </Select>
                {deliveryMethod ? renderDeliveyMethodView(deliveryMethod, contact, pickUpStore, trackingNumber) : null}
                {products.length ? renderOrdersView() : null}
                {reservations.length ? renderReservationView() : null}
            </VStack>
        </Box>
    )
}